import { useNavigate } from 'react-router-dom';
import { SitePatientEncounterApi } from 'api';
import ModalBoxes from 'common/feedback/ModalBoxes/ModalBoxes';
import Button from 'common/general/Button';
import NotificationManager from 'common/notifications/NotificationManager';
import { last } from 'lodash/array';
import { onRequestError } from 'services/handlers';

import { generateUrlByKey, useCurrentRoute } from '../../../../../../../../root/router';
import { useEncountersSection } from '../../../EncountersSectionContext';

import { useEncounterCard } from './EncounterCard';

export default function EncounterCardButton() {
  const navigate = useNavigate();
  const currentRoute = useCurrentRoute();
  const { encounter } = useEncounterCard();
  const { addAppointment } = useEncountersSection();

  const { noAppointments, ssuPatientId, encounterKey, events } = encounter;

  if (noAppointments) {
    return (
      <Button size="h28" onClick={startEncounter}>
        Start
      </Button>
    );
  }

  const lastEvent = last(events);

  return (
    <>
      <Button
        size="h28"
        onClick={function() {
          ModalBoxes.closeAll();
          addAppointment(encounterKey || lastEvent?.protocolEncounterId);
        }}
      >
        Schedule
      </Button>
    </>
  );

  function startEncounter() {
    SitePatientEncounterApi.createNoAppointmentsEncounter(ssuPatientId, encounterKey).then(
      ({ data: patientEncounterId }) => {
        ModalBoxes.closeAll();
        NotificationManager.success('No Appointments encounter was created');
        navigate(
          generateUrlByKey(`${currentRoute.key}.Encounter Details`, { ...currentRoute.params, patientEncounterId })
        );
      },
      onRequestError
    );
  }
}
